export default "__VITE_ASSET__0d0d8d41__"